import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Close } from '@mui/icons-material';
import { Button, Dialog, Grid, IconButton, Typography } from '@mui/material';

import {
  gray100,
  gray90,
  gray80,
  primaryButtonBackgroundColor,
  primaryColor,
  errorColor
} from '../../constants/Colors';
import CustomTextfield from '../uiParts/CustomTextfield';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { error } from '../../validation/text';

const modalStyles = {
  button: {
    boxSizing: 'border-box',
    height: '44px',
    width: '100%'
  },
  dialog: {
    '& .MuiDialog-paper': {
      m: '16px',
      width: '560px',
      p: '24px'
    }
  },
  text: {
    color: gray100,
    fontSize: '14px'
  },
  title: {
    color: gray100,
    fontSize: '22px',
    fontWeight: '500'
  },
  dialogRadio: {
    '&.Mui-checked': {
      color: primaryColor
    },
    color: gray90
  },
  dialogRadioLabel: {
    '& .Mui-disabled': {
      color: gray80
    },
    color: gray100
  },
  dialogRadioWrapper: {
    flexDirection: 'row',
    mb: '36px'
  },
  label: {
    fontSize: '14px'
  },
  required: {
    color: errorColor,
    fontSize: '14px',
    marginLeft: '8px'
  }
};

interface Props {
  onInvite(email: string): Promise<void>;
  onClose: () => void;
  open: boolean;
}

const InviteMemeberModal: React.FC<Props> = (props) => {
  const { onInvite, onClose, open } = props;

  const {
    control,
    watch,
    formState: { errors },
    handleSubmit,
    reset,
    clearErrors
  } = useForm<{ email: string }>({
    resolver: yupResolver(
      yup.object().shape({
        email: yup
          .string()
          .lowercase()
          .required(error.required)
          .email(error.email)
          .max(250, error.below250)
      })
    )
  });

  return (
    <Dialog open={open} sx={modalStyles.dialog}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        mb={'25px'}
      >
        <Typography sx={modalStyles.title}>共有者を招待</Typography>
        <IconButton
          onClick={() => {
            onClose();
            clearErrors();
          }}
        >
          <Close />
        </IconButton>
      </Grid>
      <Controller
        name="email"
        control={control}
        render={({ field }) => (
          <CustomTextfield
            {...field}
            value={field.value}
            onChange={field.onChange}
            error={Boolean(errors.email)}
            helperText={errors.email?.message}
            labelText="メールアドレス"
            placeholder="info@cmcos.com"
            required
            requiredText="必須"
            formMb="24px"
            width="100%"
          />
        )}
      />
      <Typography sx={modalStyles.text}>
        招待できる共有者は2名までです。
      </Typography>
      <Button
        onClick={() =>
          handleSubmit(async () => {
            await onInvite(watch('email'));
            reset();
          })()
        }
        sx={[primaryButtonBackgroundColor, modalStyles.button, { mt: '10px' }]}
        variant="contained"
      >
        招待メールを送る
      </Button>
    </Dialog>
  );
};

export default InviteMemeberModal;
